import React, {useState} from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';

import {Tracker} from '../../module/analytics';

export const NewsletterHeader = ({
  context,
  title,
  subtitle,
}: {
  context: string;
  title: string;
  subtitle: string;
}) => {
  const [showThanks, setShowThanks] = useState(false);

  const data = useStaticQuery<Queries.NewsletterHeaderImageQuery>(graphql`
    query NewsletterHeaderImage {
      file(relativePath: {eq: "parents/parent-newsletter.png"}) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE, quality: 90)
        }
      }
    }
  `);
  const headerPic = data.file?.childImageSharp
    ?.gatsbyImageData as unknown as IGatsbyImageData;

  return (
    <div className={`pt-12 text-black bg-sandwisp`}>
      <div
        className={`flex flex-col lg:flex-row justify-between max-w-screen-xl items-center py-8 md:py-16 mx-8 lg:mx-28 xl:mx-40 2xl:mx-auto gap-4`}>
        <div className="lg:w-3/5">
          <p className="text-primaryred font-semibold">{context}</p>
          <h1 className="text-h3mob md:text-h3 font-title py-2 text-left">
            {title}
          </h1>
          <p className="pt-3 text-largebodymob">{subtitle}</p>
        </div>

        <div className="w-full lg:w-2/5 pt-4 lg:pt-0">
          <div className="bg-primaryred lg:ml-8 w-full h-full rounded-2xl p-6 flex flex-col sm:flex-row justify-start gap-6">
            <div className="lg:-mt-12 lg:-ml-10 sm:w-60">
              <GatsbyImage
                image={headerPic}
                alt=""
                objectFit="cover"
                objectPosition="top"
                className="rounded-2xl max-h-52 sm:h-56 md:h-auto w-full"
              />
            </div>
            <div className="lg:w-auto">
              <p className="text-largebodymob lg:text-smallbody 2xl:text-largebody font-semibold">
                Join 100,000 other subscribers who receive luna&apos;s content
              </p>
              <div>
                <form
                  action="https://europe-west2-luna-life-prod.cloudfunctions.net/joinMailingList"
                  method="GET"
                  target="stopredirect"
                  id="newsletterSignUpForm"
                  onSubmit={() => {
                    setShowThanks(true);
                    Tracker.trackLead({leadSource: 'newsletter_sign_up'});
                  }}>
                  <div className="w-full">
                    <iframe
                      name="stopredirect"
                      id="stopredirect"
                      className="hidden"></iframe>
                    <div className="mt-6">
                      <input
                        type="text"
                        id="key"
                        name="key"
                        defaultValue="t425638l"
                        className="hidden"
                      />
                      <input
                        placeholder="Email"
                        type="email"
                        id="email"
                        name="email"
                        className="rounded-lg h-[3.5rem] p-6 font-inter border-none w-full"
                        required={true}
                      />
                      <input
                        type="text"
                        id="segments"
                        name="segments"
                        value="newsletter_parent"
                        className="hidden"
                      />
                    </div>
                    <button
                      type="submit"
                      className={`${showThanks ? 'bg-[#EBD384]' : 'bg-background'} hover:bg-[#EBD384] mt-5 text-black font-semibold text-smallbody hover:text-hoverblack w-full py-2 px-6 rounded-3xl `}
                      id="submit"
                      disabled={showThanks}>
                      {showThanks ? 'Thank you!' : 'Subscribe for free'}
                    </button>
                  </div>
                </form>
              </div>
              <div className="text-caption font-inter pt-2 lg:pt-4">
                <p>You can unsubscribe at any time</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
